// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24wwa","field":"styles_field__1xkQn","fieldCol":"styles_fieldCol__2-l0g","diffCol":"styles_diffCol__2bgYg","diff":"styles_diff__m7e7I"};